import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { IconContainer } from "../IconContainer.mjs";
import { IconBoldSvg } from "./IconBoldSvg.mjs";
const IconBold = (props) => /* @__PURE__ */ jsx(IconContainer, { ...props, children: (svgProps) => /* @__PURE__ */ jsx(Box, { component: IconBoldSvg, ...svgProps }) });
export {
  IconBold
};
